module.exports = __webpack_public_path__ + "img/icon_building_2.99829a82.png";